
import { Vue, Prop, Component } from "vue-property-decorator";
import dayjs from "dayjs";

@Component({
  name: "PostSelected"
})
export default class PostSelected extends Vue {
  @Prop() item!: Object;

  getPostedDate(date: Date) {
    return dayjs(date).format("MM/DD/YYYY");
  }
}
